import {
  IPayeeTaxFormResponse,
  TaxFormCorrectionStatus,
  TaxFormViewer
} from "@wingspanhq/payments/dist/interfaces";

export const selectorPayeeTaxFormPayeeCorrectionIsPending = (
  taxForm: IPayeeTaxFormResponse
) => {
  if (taxForm.corrections?.length) {
    const latestCorrection =
      taxForm.corrections[taxForm.corrections.length - 1];

    const isOwnedByPayee = latestCorrection.ownedBy === TaxFormViewer.payee;
    const isCreatedByPayee =
      latestCorrection.eventActors.createdBy === taxForm.memberId;

    // is pending and created by member
    return (
      latestCorrection.status === TaxFormCorrectionStatus.Pending &&
      (isOwnedByPayee || isCreatedByPayee)
    );
  }

  return false;
};
